document.addEventListener("turbolinks:load", function() {

    $('.ui.checkbox').checkbox();
    $('.ui.dropdown').dropdown();
    $('.item, .button').popup();
    $('.menu .item').tab();

    //### ВСТУПИТЕЛЬНЫЕ ЭКЗАМЕНЫ ####

    array_admission_campagn = [];

    $.each($('.ui.menu a.item[data-id1c]'), function (index, value) {
        array_admission_campagn.push($(value).attr('data-id1c'));
    });

    function selection_admission_campagn(choice_text) {
        $('#main_segment_exam').find('[data-id1c_admission_campaign="' + choice_text + '"]').removeClass('hide_display');

        $.each(array_admission_campagn, function (index, value) {
            if (choice_text != value) {
                $('#main_segment_exam').find('[data-id1c_admission_campaign="' + value + '"]').addClass('hide_display');
            }
        });
    }

    function load_item_exam(current_item) {
        current_item.addClass('active').siblings().removeClass('active');
        choice_text = current_item.attr('data-id1c');
        selection_admission_campagn(choice_text);
    }

    $('.ui.menu a.item').on('click', function () {
        load_item_exam($(this));
    });

    load_item_exam($('.ui.menu a.item[data-id1c]').first());

    $('#load_result_exam').click(function () {
        abitur_admission_compaign = $('#main_segment_exam').find('.ui.menu a.item.active[data-id1c]').attr('data-id1c');

        $.ajax({
            url: '/reference/get_result_entry_exams',
            type: 'GET',
            data: {'abitur_admission_compaign': abitur_admission_compaign},
            beforeSend: function () {
                $('#load_result_exam').addClass('loading');
            }
        });
    });

    $('#delete_result_exam').click(function () {
        abitur_admission_compaign = $('#main_segment_exam').find('.ui.menu a.item.active[data-id1c]').attr('data-id1c');

        $.ajax({
            url: '/reference/delete_result_entry_exams',
            type: 'GET',
            data: {'abitur_admission_compaign': abitur_admission_compaign},
            beforeSend: function () {
                $('#delete_result_exam').addClass('loading');
            }
        });
    });

    //### ПРИКАЗЫ ####

    //корректировка внешнего вида меню для order
    if ($('#order_menu').length != 0) {
      menu_width = $('#order_menu').css('width');
      item_width_checkbox_first = $('#order_menu .item:nth-child(2)').css('width');
      item_width_checkbox_second = $('#order_menu .item:nth-child(3)').css('width');
      item_width_button_first = $('#order_menu .item:nth-child(4)').css('width');
      item_width_button_last = $('#order_menu .item').last().css('width');

      converted_manu_width = Number(menu_width.slice(0, menu_width.length - 2)) - (Number(item_width_button_first.slice(0, item_width_button_first.length - 2)) * 3 + Number(item_width_button_last.slice(0, item_width_button_last.length - 2)) + Number(item_width_checkbox_first.slice(0, item_width_checkbox_first.length - 2)) + Number(item_width_checkbox_second.slice(0, item_width_checkbox_second.length - 2)) - 2);

      $('#order_menu .item').first().css('width', converted_manu_width);
      $('#order_menu .field').css('width', converted_manu_width);
    }

    //загрузка приказов
    $('#load_order_list').click(function() {

        arr_checked_id1c_orders = "";
        arr_additional_type_order = [];
        date = $('#order_menu input').val();
        abitur_admission_activ_id = $('#order_menu').attr('data-abitur_admission_activ_id');

        //if($('#checkbox_order_enrollment').prop('checked')){ arr_additional_type_order.push("Зачисление в вуз","Зачисление в аспирантуру");}
        if($('#checkbox_order_enrollment').prop('checked')){ arr_additional_type_order.push("Зачисление в вуз","Зачисление в аспирантуру");}
        if($('#checkbox_order_allocation').prop('checked')){ arr_additional_type_order.push("Отчисление (приемная комиссия)"); }


        if(date != "" && arr_additional_type_order.length != 0){
            $.ajax({
                url: '/reference/get_orders',
                type: 'GET',
                data: {'date': date, 'abitur_admission_activ_id': abitur_admission_activ_id, 'arr_checked_id1c_orders' : arr_checked_id1c_orders, 'arr_additional_type_order' : arr_additional_type_order},
                beforeSend: function() {
                    $('#load_order_list').addClass('loading');
                    if($('#massage .message').length != 0){
                        $('#massage .message').transition('scale');
                        $('#order_menu .field').removeClass('error');
                        $('#order_menu .ui.slider.checkbox').removeClass('error_checkbox_line error_checkbox_circle');
                        $('#order_menu .ui.slider.checkbox label').removeClass('error_text');
                    }
                }
            });
        }else{
            if($('#massage .message').length != 0) {
                $('#order_menu .field').removeClass('error');
                $('[id^="table_order_"] tr [style="background:#fff6f6"]').removeAttr('style');
                $('#massage').empty();
            }

            $('#massage').append('<div class="ui negative message" style="margin-bottom:15px;display:none"><div class="header">Нет необходимых параметров!</div><p>Необходимо указать дату, с которой Вы желаете загрузить приказы, а также выбрать вид приказа.</p></div>');

            $('#massage .message').transition('scale');
            $('#order_menu .field').addClass('error', 1000, function(){});
            $('#order_menu .ui.slider.checkbox').addClass('error_checkbox_line error_checkbox_circle', 1000, function(){});
            $('#order_menu .ui.slider.checkbox label').addClass('error_text', 1000, function(){});
        }
    });


    //обновление приказов
    $('#reload_order_list').click(function() {

        arr_checked_id1c_orders = [];
        date = "";
        arr_additional_type_order = "";
        abitur_admission_activ_id = $('#order_menu').attr('data-abitur_admission_activ_id');

        $.each($('[id^="table_order_"] tbody input[type="checkbox"]:checked'), function( index, value ){
            arr_checked_id1c_orders.push($(value).parents('tr').children('td:nth-child(2)').text());
        });

        if(arr_checked_id1c_orders.length != 0){
            $.ajax({
                url: '/reference/get_orders',
                type: 'GET',
                data: {'date': date, 'abitur_admission_activ_id': abitur_admission_activ_id, 'arr_checked_id1c_orders' : arr_checked_id1c_orders},
                beforeSend: function() {
                    $('#reload_order_list').addClass('loading');
                    if($('#massage .message').length != 0){
                        $('#massage .message').transition('scale');
                        $('#order_menu .field').removeClass('error');
                        $('#order_menu .ui.slider.checkbox').removeClass('error_checkbox_line error_checkbox_circle');
                        $('#order_menu .ui.slider.checkbox label').removeClass('error_text');
                    }
                }
            });

        }else{
            if($('#massage .message').length != 0) {
                $('#order_menu .field').removeClass('error');
                $('#order_menu .ui.slider.checkbox').removeClass('error_checkbox_line error_checkbox_circle');
                $('#order_menu .ui.slider.checkbox label').removeClass('error_text');
                $('[id^="table_order_"] tr [style="background:#fff6f6"]').removeAttr('style');
                $('#massage').empty();
            }

            $('#massage').append('<div class="ui negative message" style="margin-bottom:15px;display:none"><div class="header">Нет необходимых параметров!</div><p>Вы должны выбрать приказ. Сделать это можно с помощью чекбокса в первой колонке таблицы. Для выбора всех приказов измените чекбокc в шапке талицы.</p></div>');

            $('#massage .message').transition('scale');
            $('[id^="table_order_"] tr th.collapsing').attr('style', "background:#fff6f6");
            $('[id^="table_order_"] tr th.collapsing .ui.fitted.slider.checkbox').addClass('error_checkbox_line error_checkbox_circle');

            $.each($('[id^="table_order_"] tr'), function( index, value ){
                $(value).children('td:first').attr('style', "background:#fff6f6");
                $(value).find('td:first .ui.fitted.slider.checkbox').addClass('error_checkbox_line error_checkbox_circle');
            });
        }
    });

    //удаление приказов
    $('#delete_order_list').click(function() {

        arr_checked_id1c_orders = [];
        abitur_admission_activ_id = $('#order_menu').attr('data-abitur_admission_activ_id');

        $.each($('[id^="table_order_"] tbody input[type="checkbox"]:checked'), function( index, value ){
            arr_checked_id1c_orders.push($(value).parents('tr').children('td:nth-child(2)').text());
        });

        if(arr_checked_id1c_orders.length != 0){
            $.ajax({
                url: '/reference/delete_orders',
                type: 'GET',
                data: {'arr_checked_id1c_orders': arr_checked_id1c_orders, 'abitur_admission_activ_id': abitur_admission_activ_id},
                beforeSend: function() {
                    $('#delete_order_list').addClass('loading');
                    if($('#massage .message').length != 0){
                        $('#massage .message').transition('scale');
                        $('#order_menu .field').removeClass('error');
                        $('#order_menu .ui.slider.checkbox').removeClass('error_checkbox_line error_checkbox_circle');
                        $('#order_menu .ui.slider.checkbox label').removeClass('error_text');
                    }
                }
            });
        }else{
            if($('#massage .message').length != 0) {
                $('#order_menu .field').removeClass('error');
                $('#order_menu .ui.slider.checkbox').removeClass('error_checkbox_line error_checkbox_circle');
                $('#order_menu .ui.slider.checkbox label').removeClass('error_text');
                $('[id^="table_order_"] tr [style="background:#fff6f6"]').removeAttr('style');
                $('#massage').empty();
            }

            $('#massage').append('<div class="ui negative message" style="margin-bottom:15px;display:none"><div class="header">Нет необходимых параметров!</div><p>Вы должны выбрать приказ. Сделать это можно с помощью чекбокса в первой колонке таблицы. Для выбора всех приказов измените чекбокc в шапке талицы.</p></div>');

            $('#massage .message').transition('scale');
            $('[id^="table_order_"] tr th.collapsing').attr('style', "background:#fff6f6");
            $('[id^="table_order_"] tr th.collapsing .ui.fitted.slider.checkbox').addClass('error_checkbox_line error_checkbox_circle');

            $.each($('[id^="table_order_"] tr'), function( index, value ){
                $(value).children('td:first').attr('style', "background:#fff6f6");
                $(value).find('td:first .ui.fitted.slider.checkbox').addClass('error_checkbox_line error_checkbox_circle');
            });
        }
    });



    $('#order_list').on('change', '[id^="table_order_"] thead input[type="checkbox"]', function() {
        if($(this).prop('checked')){
            $(this).parents('table').find('tbody input[type="checkbox"]').prop('checked', true);
        }
        else{
            $(this).parents('table').find('tbody input[type="checkbox"]').prop('checked', false);
        }
    });

    $('#order_list').on('change', '[id^="table_order_"] tbody input[type="checkbox"]', function() {
        if(!$(this).prop('checked')){
            $(this).parents('table').find('thead input[type="checkbox"]').prop('checked', false);
        }
        else{
          var flag = false;

          $.each($(this).parents('tbody').find('input[type="checkbox"]'), function( index, value ){
              if ($(value).prop('checked')){
                flag = true;
              }else{
                flag = false;
                return false;
              }
          });

          if(flag == true){
              $(this).parents('table').find('thead input[type="checkbox"]').prop('checked', true);
          }
        }

    });

    //Функция подгрузки уровней образование в форму для файла
    function change_doudle_edu_level(globle_parent,local_parent,choice){

        if(choice == 1){
            change_select = globle_parent.find('#file_id .selection.multiple select option');
            change_select_div = globle_parent.find('#file_id .selection.multiple div.menu div.item');
        }
        else if(choice == 2){
            change_select = globle_parent.find('select.selection.multiple option');
            change_select_div = globle_parent.find('.selection.multiple div.menu div.item');
        }

        array_select_text = [];
        array_select_value = [];
        array_chack = [];
        sum_select = "";

        local_parent.find('select option:selected').each(function(index, value){
            if($(value).attr('value') != ""){
                array_select_text.push($(value).text());
                array_select_value.push($(value).attr('value'));
            }
        });

        if(choice == 1){
          globle_parent.find('#file_id .selection.multiple select option:selected').prop('selected', false);
          globle_parent.find('#file_id .selection.multiple div.menu div.item').removeClass('selected active filtered');
        }
        else if(choice == 2){
          $(globle_parent).find('select.selection.multiple  option:selected').prop('selected', false);
          $(globle_parent).find('.selection.multiple div.menu div.item').removeClass('selected active filtered');
        }

        for(i=0;i<array_select_text.length;i++){
            for(j=0;j<change_select.length;j++){
                if(array_select_text[i] == $(change_select[j]).text()){
                    $(change_select[j]).prop('selected', true);
                    if(array_chack.indexOf(array_select_text[i]) == -1){
                        sum_select += '<a class="ui label transition visible" data-value="' + array_select_value[i] + '" style="display: inline-block !important;">'+ array_select_text[i] +'<i class="delete icon"></i></a>';
                        array_chack.push(array_select_text[i]);
                    }
                }
            }
            for(c=0;c<change_select_div.length;c++){
                if($(array_select_text[i] == change_select_div[c]).text()){
                    $(change_select_div[c]).addClass('active filtered');
                }
            }
        }

        if(choice == 1){
          globle_parent.find('#file_id .selection.multiple div.menu ').addClass('transition hidden');
          globle_parent.find('#file_id .selection.multiple a.ui.label').remove();
          globle_parent.find('#file_id .selection.multiple i.dropdown.icon').after(sum_select);
        }
        else if(choice == 2){
          $(globle_parent).find('.selection.multiple div.menu ').addClass('transition hidden');
          $(globle_parent).find('.selection.multiple a.ui.label').remove();
          $(globle_parent).find('.selection.multiple i.dropdown.icon').after(sum_select);
        }
    }

    // Изменение уровня образования
    $('#document_10, #document_11, #document_15, #document_25, #document_26').on('change', '.selection.dropdown.multiple.onelevel', function() {
        globle_parent = $(this).parents('.nested-fields.ui.message');
        globle_parent.find('.button.disabled').removeClass('disabled');
        local_parent = $(this).parents('.field');

        change_doudle_edu_level(globle_parent,local_parent,1);
    });

    $('#document_10, #document_15').on('change', '.change_kind', function() {
        kind_id = $(this).find('option:selected').val();
        globle_parent = $(this).parents('.nested-fields.ui.message');
        local_parent = globle_parent.find('input[type=hidden].x').last().val(kind_id);
    });


    // Удаление класса disabled у кнопульки добавления файла и формирование id для формы файла, для существующих
    $('.nested-fields.ui.message.double_unit').each(function(i,elem){
        if($(elem).find('select[multiple]').val() != ""){
            $(this).find('#add_button_file').removeClass('disabled');
        }
        rand_index =  Math.floor(Math.random()*100000);
        $(elem).find('div#file_for_reception_').attr('id', 'file_for_reception_' + rand_index +'');
        $(elem).find('a.tiny').attr('data-association-insertion-node', '#file_for_reception_' + rand_index +'');
    });

    var glob_parent;
    var loc_parent;
    var kind_id;
    var flag_doc_use = 0

    // добавление типа родителя в файл
    $('#document_10, #document_11, #document_15').on('click', '.tiny', function() {
        glob_parent = $(this).parents('.nested-fields.ui.message');
        loc_parent = glob_parent.find('div.multiple.onelevel').parents('.field');
        chack_choice = glob_parent.find('div.multiple.onelevel select option:selected').val();
        kind_id = glob_parent.find('select').val();
        //loc_parent.find('input[type=hidden].x').val(kind_id);
    });

    // добавление уровня образования
    $('#document_25, #document_26').on('click', '.tiny', function() {
        glob_parent = $(this).parents('.nested-fields.ui.message');
        loc_parent = glob_parent.find('div.multiple.onelevel').parents('.field');
        chack_choice = glob_parent.find('div.multiple.onelevel select option:selected').val();
       // console.log("chack_choice " + $(chack_choice).html() + chack_choice);
        flag_doc_use = 25
    });

    // добавление уровня образования в форму файла
    $('#document_10,  #document_11, #document_15, #document_25, #document_26').on('cocoon:after-insert', '.file_hustle', function(e, insertItem) {
        if (chack_choice != undefined){
            // console.log(kind_id);
            if (flag_doc_use != 25){insertItem.find('input[type=hidden].x').last().val(kind_id);}
            change_doudle_edu_level(insertItem,loc_parent,2);
        }
        insertItem.find('select.multiple.towlevel').attr('disabled', 'disabled');
    });


    // Создание id для вставки файлов
    $('#document_10, #document_11, #document_15, #document_25, #document_26').on('cocoon:before-insert', function(e, insertItem) {
        add_index =  Math.floor(Math.random()*100000);
        insertItem.find('div#file_for_reception_').attr('id', 'file_for_reception_' + add_index +'');
        insertItem.find('a.tiny').attr('data-association-insertion-node', '#file_for_reception_' + add_index +'');
    });

    // Добавление disabled в уровни образования в формы для файлов
    $('body').find('.nested-fields.ui.message.double_unit div.towlevel').addClass('disabled');

    // Удаление disabled передотправкой формы
    $('#abitur_submit_button').click(function(){
        $('body').find('.towlevel select').removeAttr('disabled');
    });

    $('#abitur_total_info, #hot_line')
        .on('cocoon:after-insert', function() {
            $('#abitur_total_info,#hot_line .myeditor').froalaEditor({
                initOnClick: true,
                toolbarInline: false,
                file: false,
                language: 'ru'
            });
        });


    // Шаги
    var step_value = 0;

    $('#button_next_one, #button_next_two, #button_next_three, #button_next_four').click(function() {

        if (step_value == 0){
            $('#one_step').addClass('none_segment');
            $('#two_step').removeClass('none_segment');
            $('#step_one_header').removeClass('active');
            $('#step_one_header').addClass('disabled');
            $('#step_two_header').removeClass('disabled');
            $('#step_two_header').addClass('active');

            step_value++;
        }
        else if (step_value == 1) {
            $('#two_step').addClass('none_segment');
            $('#three_step').removeClass('none_segment');
            $('#step_two_header').removeClass('active');
            $('#step_two_header').addClass('disabled');
            $('#step_three_header').removeClass('disabled');
            $('#step_three_header').addClass('active');

            step_value++;
        }
        else if (step_value == 2) {
            $('#three_step').addClass('none_segment');
            $('#four_step').removeClass('none_segment');
            $('#step_three_header').removeClass('active');
            $('#step_three_header').addClass('disabled');
            $('#step_four_header').removeClass('disabled');
            $('#step_four_header').addClass('active');

            step_value++;
        }
        else if (step_value == 3) {
            $('#four_step').addClass('none_segment');
            $('#five_step').removeClass('none_segment');
            $('#step_four_header').removeClass('active');
            $('#step_four_header').addClass('disabled');
            $('#step_five_header').removeClass('disabled');
            $('#step_five_header').addClass('active');

            step_value++;
        }
    });



    $('#button_back_two, #button_back_three, #button_back_four, #button_back_five').click(function() {

        if (step_value == 1){
            $('#two_step').addClass('none_segment');
            $('#one_step').removeClass('none_segment');
            $('#step_one_header').removeClass('disabled');
            $('#step_one_header').addClass('active');
            $('#step_two_header').removeClass('active');
            $('#step_two_header').addClass('disabled');

            step_value--;
        }
        else if (step_value == 2) {
            $('#three_step').addClass('none_segment');
            $('#two_step').removeClass('none_segment');
            $('#step_two_header').removeClass('disabled');
            $('#step_two_header').addClass('active');
            $('#step_three_header').removeClass('active');
            $('#step_three_header').addClass('disabled');

            step_value--;
        }
        else if (step_value == 3) {
            $('#four_step').addClass('none_segment');
            $('#three_step').removeClass('none_segment');
            $('#step_three_header').removeClass('disabled');
            $('#step_three_header').addClass('active');
            $('#step_four_header').removeClass('active');
            $('#step_four_header').addClass('disabled');

            step_value--;
        }
        else if (step_value == 4) {
            $('#five_step').addClass('none_segment');
            $('#four_step').removeClass('none_segment');
            $('#step_four_header').removeClass('disabled');
            $('#step_four_header').addClass('active');
            $('#step_five_header').removeClass('active');
            $('#step_five_header').addClass('disabled');

            step_value--;
        }
    });


    // Отчистка сообщений при переходи на следующий шаг
    $('#button_next_one, #button_next_two, #button_back_two, #button_next_three, #button_back_three, #button_back_four, #button_next_four, #button_back_five').click(function(){
        $('div.warning.message').removeClass('goode_mes');
        $('div.warning.message').removeClass('warning_mes');
        $('div.warning.message').empty();
        $('div.warning.message').append('<i class ="info icon"></i> Сообщения');
    });

    // залочка кнопки дальше
    function check_exists_segment() {
        if($('div').is('.ui.segment') != true){
            $('#button_next_one').addClass('disabled');
        }
    }

    // проверка для разлочивания кнопки далее
    if($('div').is('.ui.segment') == true){
        $('#button_next_one').removeClass('disabled');
    }

    //текущие время
    var currentTime = new Date();
    var yearCurr = currentTime.getFullYear();

    // ajax-загрузка приемных кампаний
    $('#button_load_admission_campaigns').click(function(){

        /*if($('#input_year').val() == ''){
            $('#input_year').addClass('warning_input');
            $('.warning.message').removeClass('goode_mes');
            $('.warning.message').addClass('warning_mes');
            $('div.warning.message').empty();
            $('div.warning.message').append('<i class ="warning icon"></i> Вы не указали год или ввели невалидное значение');
        }
        else if($('#input_year').val() > yearCurr){
            $('#input_year').addClass('warning_input');
            $('.warning.message').removeClass('goode_mes');
            $('.warning.message').addClass('warning_mes');
            $('div.warning.message').empty();
            $('div.warning.message').append('<i class ="warning icon"></i> Хорошая попытка, но попробуте еще разок');
        }
        else if($('#input_year').val() != $('[data-abitur_admission_active_year]').attr('data-abitur_admission_active_year')){

        }
        else{*/
            $('#input_year').removeClass('warning_input');
            $('.warning.message').removeClass('warning_mes');
            $('.warning.message').addClass('goode_mes');
            $('div.warning.message').empty();
            $('div.warning.message').append('<i class ="info icon"></i> Процесс загрузки, ожидайте ');

            //year_admission_campaign = $('#input_year').val();
            year_admission_campaign = $('[data-abitur_admission_active_year]').attr('data-abitur_admission_active_year');
            id_admission_active = $('[data-abitur_admission_active_id]').attr('data-abitur_admission_active_id');

            $.ajax({
                url: '/reference/get_admission_campaigns',
                type: 'GET',
                data: {'year_admission_campaign' : year_admission_campaign, 'id_admission_active' : id_admission_active},
                datType: 'json',
                beforeSend: function() {
                    $('#button_load_admission_campaigns').empty();
                    $('#button_load_admission_campaigns').append('<i class ="left load_button loading exchange icon"></i>Загрузить приемных кампаний');
                },
                success: function(current_hash) {

                    $('#button_load_admission_campaigns').empty();
                    $('#button_load_admission_campaigns').append('<i class ="left exchange icon"></i>Загрузка приемных кампаний');

                    if(current_hash == "") {
                        $('#input_year').addClass('warning_input');
                        $('.warning.message').removeClass('goode_mes');
                        $('.warning.message').addClass('warning_mes');
                        $('div.warning.message').empty();
                        $('div.warning.message').append('<i class ="warning icon"></i> В ' + year_admission_campaign + ' году не создано ни одной приемной кампании');
                    }
                    else{
                        $('div.warning.message').empty();
                        $('div.warning.message').append('<i class ="info icon"></i> Загрузка прошла успешно');

                        var id1c;
                        var date;
                        var type;
                        var id = 1;

                        for (var i = 0; i < current_hash.length; i++){

                            $.each(current_hash[i], function(key, value){
                                if(key == 'id'){
                                    id = value;
                                }else if(key == 'id1c'){
                                    id1c = value;
                                }else if(key == 'date_start'){
                                    date = value;
                                    year = date.substring(0,4);
                                    day = date.substring(8,10);
                                    month = date.substring(5,7);
                                }else if(key == 'type_admission_campaign'){
                                    type = value;
                                }

                            });

                            $('<tr><td class="collapsing"><div class="ui fitted slider checkbox"><input type="checkbox" tabindex="0" class="hidden"><label></label></div></td><td>' + id1c + '</td><td>' + day + '.'+ month + '.' + year + '</td><td>' + type + '</td><td data-id="'+ id +'"><div class="ui icon button red stub"><i class="trash icon"></i></div></td></tr>').appendTo('tbody#admissionCampaigns').hide().fadeIn(600);
                        }
                        $('.ui.checkbox').checkbox();
                    }
                }
            });
        //}
    });

    // маска ввода для года приемной кампании
    $('#input_year').mask("9999");

    //удаление приемной кампании ajax
    var delete_id;
    var current_tr;

    //удаление отдельных приемных кампаний добавленных ajax-сом
    $('#admissionCampaigns').on('click', '.ui.icon.button.red.stub', function(){

        if(confirm("При удалении приемной кампании будут удалены все зависимые объекты: конкурсные группы, цифры приема, вступительные экзамены. Вы точно хотите удалить приемную кампанию?")){
            delete_id = $(this).parent().attr('data-id');
            delete_id1c = $(this).parents('tr').find('td:nth-child(2)').text();
            current_tr = $(this).parents('tr');

            $.ajax({
                url: '/reference/delete_admission_campaign',
                type: 'GET',
                data: {'delete_id' : delete_id},
                datType: 'html',
                beforeSend: function() {},
                success: function(current_hash) {
                    $('.warning.message').removeClass('warning_mes');
                    $('.warning.message').addClass('goode_mes');
                    $('div.warning.message').empty();
                    $('div.warning.message').append('<i class ="info icon"></i> Удаление приемной кампании прошло успешно');

                    if(current_hash == 'true'){
                        $(current_tr).fadeOut(600);
                        setTimeout( function(){
                                $(current_tr).remove();
                            }
                            , 1000);

                        $('#two_step').find('.ui.segment#id_admission_campaign_' + delete_id).remove();
                        $('#three_step').find('.ui.segment#id_admission_campaign_np_' + delete_id).remove();
                        $('#four_step').find('.ui.segment#id_admission_campaign_ex_' + delete_id).remove();
                        $('#five_step').find('.ui.segment#id_admission_campaign_qaa_' + delete_id).remove();

                        check_exists_segment();
                        arr_id1c_admission_campaign.remove(delete_id1c);
                    }
                }
            });
        }
    });

    // удаление всех приемных кампаний
    $('#button_remove_admission_campaigns').click(function(){

        if(confirm("При удалении приемых кампаний будут удалены все зависимые объекты: конкурсные группы, цифры приема, вступительные экзамены. Вы точно хотите удалить приемные кампании?")){

            $.ajax({
                url: '/reference/delete_all_admission_campaigns',
                type: 'GET',
                datType: 'html',
                beforeSend: function() {},
                success: function(current_hash) {
                    $("div.warning.message").empty();
                    $('.warning.message').removeClass('warning_mes');
                    $('.warning.message').addClass('goode_mes');
                    $("div.warning.message").append('<i class ="info icon"></i> Удаление приемных кампаний прошло успешно');

                    if(current_hash == 'true'){
                        $('#admissionCampaigns').fadeOut(600);
                        setTimeout( function(){
                                $('#admissionCampaigns').empty();
                                $('tbody#admissionCampaigns[style]').removeAttr('style');
                            }
                            , 1000);
                        $('#competitiveGroups, #numberAdmission, #admissionTests, #quantityAppApp').find('.ui.segment').remove();
                        check_exists_segment();
                        arr_id1c_admission_campaign = [];
                    }
                }
            });
        }

    });

    // получение массива выбранных приемных кампаний
    var value_checkbox;
    var arr_id1c_admission_campaign = [];

    // свойство для удаления элементов
    Array.prototype.remove = function(value) {
        var idx = this.indexOf(value);
        if (idx != -1) {
            // Второй параметр - число элементов, которые необходимо удалить
            return this.splice(idx, 1);
        }
        return false;
    };


    // собираем массив премных кампаний для ajax-запроса
    $('#admissionCampaigns').on('change click', 'input:checkbox', function(){

        // удаление/добавление класса disabled кнопольки 'далее'
        if($('.checked').length == 0 && $('div').is('.ui.segment' ) == false){
            $('#button_next_one').addClass('disabled');
        }
        else{
            $('#button_next_one').removeClass('disabled');
        }


        value_checkbox = $(this).parents('td').next().text();

        if($.inArray(value_checkbox, arr_id1c_admission_campaign) == -1){
            arr_id1c_admission_campaign.push(value_checkbox);
            $("div.warning.message").empty();
            $('.warning.message').removeClass('warning_mes');
            $('.warning.message').addClass('goode_mes');
            $("div.warning.message").append('<i class ="info icon"></i> Вы выбрали приемную кампаню номер '+ value_checkbox +'. Для зягрузки конкурсных группы перейдите на шаг "Конкурсные группы".');
            console.log(arr_id1c_admission_campaign);
        }
        else{
            arr_id1c_admission_campaign.remove(value_checkbox);
            $("div.warning.message").empty();
            $('.warning.message').removeClass('warning_mes');
            $('.warning.message').addClass('goode_mes');
            $("div.warning.message").append('<i class ="info icon"></i> Вы отмениели выбор приемной кампании номер '+ value_checkbox +'. Напоминаем, что для загрузки конкурсных должна быть выбрана хотябы одня приемная кампания.');
            console.log(arr_id1c_admission_campaign);
        }
    });


    // загрузка конкурсных групп
    $('#button_load_competitive_groups').click(function() {

        if (arr_id1c_admission_campaign.length == 0) {
            $('#two_step .warning.message').removeClass('goode_mes');
            $('#two_step .warning.message').addClass('warning_mes');
            $('#two_step div.warning.message').empty();
            $('#two_step div.warning.message').append('<i class ="warning icon"></i> Вы не выбрали приемную кампанию для загрузки конкурсных групп. Вернитесь на шаг "Приемная кампания".');
        }
        else{
            var c = 0
            setAjaxCompetitiveGroup(arr_id1c_admission_campaign, c);

            function setAjaxCompetitiveGroup(arr_id1c_admission_campaign, c) {

                $.ajax({
                    url: '/reference/get_competitive_groups',
                    type: 'GET',
                    data: {'id_admission_campaign': arr_id1c_admission_campaign[c]},
                    datType: 'json',
                    beforeSend: function () {
                        $('#button_load_competitive_groups').empty();
                        $('#button_load_competitive_groups').append('<i class ="left load_button loading exchange icon"></i>Загрузить конкурсные группы');
                    },
                    success: function (current_hash) {

                        if (current_hash.length != 2) {

                            $('#button_load_competitive_groups').empty();
                            $('#button_load_competitive_groups').append('<i class ="left exchange icon"></i>Загрузить конкурсные группы');
                            $('#two_step .warning.message').removeClass('warning_mes');
                            $('#two_step .warning.message').addClass('goode_mes');
                            $('#two_step div.warning.message').empty();
                            $('#two_step div.warning.message').append('<i class ="info icon"></i> Загрузка конкурсных групп прошла успешно');


                            if ($('div').is('#id_admission_campaign_' + current_hash[1]) == false) {
                                $('<div class="ui segment" id = "id_admission_campaign_' + current_hash[1] + '"><div class="ui accordion"><div class="title"><i class="dropdown icon"></i>Приемна кампания номер ' + current_hash[0] + '</div><div class="content"><p class="transition visible" style="display: block !important;"></p><table class="ui very basic table transition visible" style="display: table !important;"><thead><tr><th>№</th><th>Наименование</th><th>Форма обучения</th><th>Основание поступления</th><th>Особое право</th><th>Удалить</th></tr></thead><tbody id = "competitive_groups_' + current_hash[1] + '" ></tbody></table><p class="transition visible" style="display: block !important;"></p></div></div></div>').appendTo('#competitiveGroups').hide().fadeIn(600);

                                $('.ui.accordion').accordion({
                                    onOpen: function () {
                                        $("html, body").animate({
                                            scrollTop: $(this, '.title.active').offset().top - 40
                                        }, 1000)
                                    }
                                });

                                flag_add = 0;
                            } else {
                                flag_add = 1;
                            }

                            var id;
                            var performance_c_g;
                            var edu_form_id;
                            var abitur_basis_admission_id;
                            var abitur_admission_campaign_id;
                            var edu_special_right;
                            var i = 0;

                            for (var j = 2; j < current_hash.length; j++) {

                                $.each(current_hash[j], function (key, value) {

                                    if (key == 'id') {
                                        id = value;
                                    }
                                    else if (key == 'performance_c_g') {
                                        performance_c_g = value;
                                    }
                                    else if (key == 'edu_form_id') {
                                        if (value == 1) {
                                            edu_form_id = "Заочная";
                                        }
                                        if (value == 2) {
                                            edu_form_id = "Заочная ускоренная";
                                        }
                                        if (value == 3) {
                                            edu_form_id = "Очная";
                                        }
                                        if (value == 4) {
                                            edu_form_id = "Очно-заочная";
                                        }
                                        if (value == 5) {
                                            edu_form_id = "Сокращенная";
                                        }
                                    }
                                    else if (key == 'abitur_admission_campaign_id') {
                                        abitur_admission_campaign_id = value;
                                    }
                                    else if (key == 'abitur_basis_admission_id') {
                                        if (value == 2) {
                                            abitur_basis_admission_id = "Бюджетная основа (квота лиц имеющих особое право)";
                                        }
                                        if (value == 3) {
                                            abitur_basis_admission_id = "Полное возмещение затрат";
                                        }
                                        if (value == 4) {
                                            abitur_basis_admission_id = "Бюджетная основа";
                                        }
                                        if (value == 5) {
                                            abitur_basis_admission_id = "Целевой прием";
                                        }
                                    } else if (key == 'edu_special_right') {
                                        if (value == 'f') {
                                            edu_special_right = 'Нет';
                                        } else {
                                            edu_special_right = 'Да';
                                        }
                                    }

                                });
                                if (flag_add == 0) {
                                    i++;
                                    $('<tr class="renewal"><td  class="stub_count">' + i + '</td><td>' + performance_c_g + '</td><td>' + edu_form_id + '</td><td>' + abitur_basis_admission_id + '</td><td>' + edu_special_right + '</td><td data-id-competitive-group = "' + id + '"><div class="ui icon button red stub"><i class="trash icon"></i></div></td></tr>').appendTo('tbody#competitive_groups_' + abitur_admission_campaign_id).hide().fadeIn(600);
                                }
                                else {
                                    last_number_ac = $('#id_admission_campaign_' + current_hash[1] + ' .stub_count').length;
                                    new_last_number_ac = Number(last_number_ac) + 1;
                                    $('tbody#competitive_groups_' + abitur_admission_campaign_id + ' > tr:last').before('<tr class="renewal"><td class="stub_count">' + new_last_number_ac + '</td><td>' + performance_c_g + '</td><td>' + edu_form_id + '</td><td>' + abitur_basis_admission_id + '</td><td>' + edu_special_right + '</td><td data-id-competitive-group = "' + id + '"><div class="ui icon button red stub"><i class="trash icon"></i></div></td></tr>').prev().hide().fadeIn(600);
                                }
                            }

                            if ($('td').is('[data-id_admission_campaign=' + current_hash[1] + ']') == false) {
                                $('<tr><td></td><td></td><td></td><td colspan="3" class="stub_delete_competitive_group" data-id_admission_campaign = "' + current_hash[1] + '"><div class="ui right floated right labeled icon red button" id="button_remove"><i class="right trash icon"></i>Удалить весь список</div></td></tr>').appendTo('tbody#competitive_groups_' + current_hash[1]).hide().fadeIn(600);
                            }
                        }
                        else {
                            $('#button_load_competitive_groups').empty();
                            $('#button_load_competitive_groups').append('<i class ="left exchange icon"></i>Загрузить конкурсные группы');
                            $('#two_step .warning.message').removeClass('goode_mes');
                            $('#two_step .warning.message').addClass('warning_mes');
                            $('#two_step div.warning.message').empty();
                            $('#two_step div.warning.message').append('<i class ="warning icon"></i> Не удалось загрузить конкурсные группы');
                        }
                        c++;
                        if(c < arr_id1c_admission_campaign.length){setAjaxCompetitiveGroup(arr_id1c_admission_campaign, c);}
                    }
                });
            }
        }
    });


    // удаление всех конкурсных групп
    $('#competitiveGroups').on('click', '.stub_delete_competitive_group', function(){

        delete_id_admission_campaign =  $(this).attr('data-id_admission_campaign');

        if(confirm("При удалении конкурсных групп будут удалены все зависимые объекты: цифры приема и вступительные экзамены. Вы точно хотите удалить конкурсные группы?")){

            $.ajax({
                url: '/reference/delete_all_competitive_groups',
                type: 'GET',
                data: {'delete_id_admission_campaign' : delete_id_admission_campaign},
                datType: 'json',
                beforeSend: function() {},
                success: function(current_hash) {
                    $('#two_step div.warning.message').empty();
                    $('#two_step .warning.message').removeClass('warning_mes');
                    $('#two_step .warning.message').addClass('goode_mes');
                    $('#two_step div.warning.message').append('<i class ="info icon"></i> Удаление конкурсных групп прошло успешно');

                    if(current_hash[1] == 'true'){
                        $('div#id_admission_campaign_' + current_hash[0]).fadeOut(600);
                        setTimeout( function(){
                                $('div#id_admission_campaign_' + current_hash[0]).remove();
                            }
                            , 1000);

                        $('#three_step').find('.ui.segment#id_admission_campaign_np_' + delete_id_admission_campaign).remove();
                        $('#four_step').find('.ui.segment#id_admission_campaign_ex_' + delete_id_admission_campaign).remove();
                        $('#five_step').find('.ui.segment#id_admission_campaign_qaa_' + delete_id_admission_campaign).remove();
                    }
                }
            });
        }

    });

    // пересчет порядковых номеров
    function countingOrdinalNumbers(arr){
        f = 1;
        for(var t = 0; t < arr.length; t++){
            $(arr[t]).find('td:first').text(f);
            f++;
        }
    }

    // удаление отдельной конкурсной группы
    var delete_id_competitive_group;
    $('#competitiveGroups').on('click', '.ui.icon.button.red.stub', function(){

        if(confirm("При удаление конкурсной группы будут удалены все зависимые объекты: цифры приема, вступительные экзамены. Вы точно хотите удалить конкурсную группу?")){

            delete_id_competitive_group = $(this).parent().attr('data-id-competitive-group');
            parent_elemet_delete = $(this).parents('tbody');
            current_tr = $(this).parents('tr');

            $.ajax({
                url: '/reference/delete_competitive_group',
                type: 'GET',
                data: {'delete_id_competitive_group' : delete_id_competitive_group},
                datType: 'html',
                beforeSend: function() {},
                success: function(current_hash) {
                    $('#two_step div.warning.message').empty();
                    $('#two_step .warning.message').removeClass('warning_mes');
                    $('#two_step .warning.message').addClass('goode_mes');
                    $('#two_step div.warning.message').append('<i class ="info icon"></i> Удаление конкурсной группы прошло успешно');

                    if(current_hash == 'true'){
                        $(current_tr).fadeOut(600);
                        setTimeout( function(){
                                $(current_tr).remove();

                                arr = parent_elemet_delete.find('tr');
                                var f = 1;
                                for(var t = 0; t < arr.length-1; t++){
                                    $(arr[t]).find('td:first').text(f).hide().fadeIn(600);
                                    f++;
                                }
                            }
                            , 610);

                        three_step_parent_elemet_delete =  $('#three_step').find('td[data-id-competitive-group=' + delete_id_competitive_group + ']').parents('tbody');
                        $('#three_step').find('td[data-id-competitive-group=' + delete_id_competitive_group + ']').parents('tr').remove();
                        arr = three_step_parent_elemet_delete.find('tr.renewal');
                        countingOrdinalNumbers(arr);

                        four_step_parent_elemet_delete = $('#four_step').find('tr[data-id-competitive-group=' + delete_id_competitive_group + ']').parents('tbody');
                        $('#four_step').find('tr[data-id-competitive-group=' + delete_id_competitive_group + ']').remove();
                        arr = four_step_parent_elemet_delete.find('tr.score');
                        countingOrdinalNumbers(arr);

                        five_step_parent_elemet_delete =  $('#five_step').find('td[data-id-competitive-group=' + delete_id_competitive_group + ']').parents('tbody');
                        $('#five_step').find('td[data-id-competitive-group=' + delete_id_competitive_group + ']').parents('tr').remove();
                        arr = five_step_parent_elemet_delete.find('tr.renewal');
                        countingOrdinalNumbers(arr);
                    }
                }
            });

        }

    });



    //загрузка цифр приема
    $('#button_load_number_places_admission').click(function() {

        if (arr_id1c_admission_campaign.length == 0) {
            $('#three_step .warning.message').removeClass('goode_mes');
            $('#three_step .warning.message').addClass('warning_mes');
            $('#three_step div.warning.message').empty();
            $('#three_step div.warning.message').append('<i class ="warning icon"></i> Вы не выбрали приемную кампанию для загрузки цифр приема. Вернитесь на шаг "Приемная кампания".');
        }
        else {

            flag_refresh = 0;
            var c = 0
            setAjaxNumberPlacesAdmission(arr_id1c_admission_campaign, c);

            function setAjaxNumberPlacesAdmission(arr_id1c_admission_campaign, c) {

                $.ajax({
                    url: '/reference/get_number_places_admission',
                    type: 'GET',
                    data: {'id_admission_campaign': arr_id1c_admission_campaign[c], 'flag_refresh': flag_refresh},
                    datType: 'json',
                    beforeSend: function () {
                        $('#button_load_number_places_admission').empty();
                        $('#button_load_number_places_admission').append('<i class ="left load_button loading exchange icon"></i>Загрузить места приёма');
                    },
                    success: function (current_hash) {

                        if (current_hash.length != 2) {

                            $('#button_load_number_places_admission').empty();
                            $('#button_load_number_places_admission').append('<i class ="left exchange icon"></i>Загрузить места приёма');
                            $('#three_step .warning.message').removeClass('warning_mes');
                            $('#three_step .warning.message').addClass('goode_mes');
                            $('#three_step div.warning.message').empty();
                            $('#three_step div.warning.message').append('<i class ="info icon"></i> Загрузка цифры приема прошла успешно');

                            if ($('div').is('#id_admission_campaign_np_' + current_hash[1]) == false) {
                                $('<div class="ui segment" id = "id_admission_campaign_np_' + current_hash[1] + '"><div class="ui accordion"><div class="title"><i class="dropdown icon"></i>Приемна кампания номер ' + current_hash[0] + '</div><div class="content"><p class="transition visible" style="display: block !important;"></p><table class="ui very basic table transition visible" style="display: table !important;"><thead><tr><th>№</th><th>Наименование</th><th>Форма обучения</th><th>Основание поступления</th><th>Особое право</th><th>Цифры приема</th><th>Удалить</th></tr></thead><tbody id = "number_places_' + current_hash[1] + '" ></tbody></table><p class="transition visible" style="display: block !important;"></p></div></div></div>').appendTo('#numberAdmission').hide().fadeIn(600);
                                $('.ui.accordion').accordion({
                                    onOpen: function () {
                                        $("html, body").animate({
                                            scrollTop: $(this, '.title.active').offset().top - 40
                                        }, 1000)
                                    }
                                });
                                flag_laod = 0;
                            } else {
                                flag_laod = 1;
                            }


                            for (var j = 2; j < current_hash.length; j++) {
                                // получение значенией текущего хэша
                                $.each(current_hash[j], function (key, value) {
                                    if (key == 'abitur_admission_campaign_id') {
                                        abitur_admission_campaign_id = value;
                                    } else if (key == 'abitur_competitive_group_id') {
                                        abitur_competitive_group_id = value;
                                    } else if (key == 'number_places') {
                                        number_places = value;
                                    }

                                });

                                // получение конкурсных групп загруженых на 2 шаге и добавление в них места приема
                                $('#two_step #id_admission_campaign_' + current_hash[1] + ' tbody > tr').each(function () {

                                    if ($(this).children('td:last').attr('data-id-competitive-group') == abitur_competitive_group_id) {

                                        clone_current_tr = $(this).clone();

                                        if (flag_laod == 1) {

                                            last_number = $('#id_admission_campaign_np_' + current_hash[1] + ' .stub_refresh').length;
                                            new_last_number = Number(last_number) + 1;
                                            first_td = $(clone_current_tr).find('td:first').text(new_last_number);
                                            last_td = $(clone_current_tr).find('td:last');
                                            $(last_td).before('<td class="stub_refresh" >' + number_places + '</td>');
                                            $('tbody#number_places_' + abitur_admission_campaign_id + ' > tr:last').before(clone_current_tr).prev().hide().fadeIn(600);

                                        }
                                        else {
                                            last_td = $(clone_current_tr).find('td:last');
                                            $(last_td).before('<td class="stub_refresh" >' + number_places + '</td>');
                                            console.log(clone_current_tr.html());
                                            $(clone_current_tr).appendTo('tbody#number_places_' + abitur_admission_campaign_id).hide().fadeIn(600);
                                        }

                                    }

                                });
                            }

                            if ($('td').is('[data-id_admission_campaign_np=' + current_hash[0] + ']') == false) {
                                $('<tr><td colspan="4" class="stub_refresh_number_places" data-id_admission_campaign_np="' + current_hash[0] + '" ><div class="ui right floated right labeled icon blue button" id="button_refresh_number_places"><i class="right refresh icon"></i>Обновить весь список</div></td><td colspan="3" class="stub_remove_number_places" data-id_admission_campaign = "' + current_hash[1] + '"><div class="ui right floated right labeled icon red button" id="button_remove_number_places"><i class="right trash icon"></i>Удалить весь список</div></td></tr>').appendTo('tbody#number_places_' + current_hash[1]).hide().fadeIn(600);
                            }

                        }
                        else {
                            $('#button_load_number_places_admission').empty();
                            $('#button_load_number_places_admission').append('<i class ="left exchange icon"></i>Загрузить места приёма');
                            $('#three_step .warning.message').removeClass('goode_mes');
                            $('#three_step .warning.message').addClass('warning_mes');
                            $('#three_step div.warning.message').empty();
                            $('#three_step div.warning.message').append('<i class ="warning icon"></i> Не удалось загрузить цифры приема');
                        }
                        c++;
                        if(c < arr_id1c_admission_campaign.length){setAjaxNumberPlacesAdmission(arr_id1c_admission_campaign, c);}
                    }
                });

            }
        }

    });


    // обновление цифр прием
    $('#numberAdmission').on('click', '#button_refresh_number_places', function(){

        refresh_id_admission_campaign = $(this).closest('.stub_refresh_number_places').attr('data-id_admission_campaign_np');
        flag_refresh = 1;

        $.ajax({
            url: '/reference/get_number_places_admission',
            type: 'GET',
            data: {'id_admission_campaign': refresh_id_admission_campaign, 'flag_refresh': flag_refresh},
            datType: 'json',
            beforeSend: function () {
                $('#button_refresh_number_places').empty();
                $('#button_refresh_number_places').append('<i class ="right load_button loading refresh icon"></i>Обновить весь список');

            },
            success: function (current_hash){

                $('#button_refresh_number_places').empty();
                $('#button_refresh_number_places').append('<i class ="right refresh icon"></i>Обновить весь список');
                $('#three_step .warning.message').removeClass('warning_mes');
                $('#three_step .warning.message').addClass('goode_mes');
                $('#three_step div.warning.message').empty();
                $('#three_step div.warning.message').append('<i class ="info icon"></i> Обновление цифры приема прошла успешно');

                for(var j = 2; j < current_hash.length; j++) {

                    // получение значенией текущего хэша
                    $.each(current_hash[j], function (key, value) {
                        if(key == 'abitur_admission_campaign_id'){
                            abitur_admission_campaign_id = value;
                        }else if(key == 'abitur_competitive_group_id'){
                            abitur_competitive_group_id = value;
                        }else if(key == 'number_places'){
                            number_places = value;
                        }

                    });

                    tr_find = $('#id_admission_campaign_np_' + current_hash[1]).find('td[data-id-competitive-group = "' + abitur_competitive_group_id + '"]');
                    $(tr_find).prev('td').text(number_places).hide().fadeIn(600);

                }
            }
        });

    });

    //удаление всех цифр приема
    $('#numberAdmission').on('click', '#button_remove_number_places', function(){

        delete_id_admission_campaign_np =  $(this).closest('.stub_remove_number_places').attr('data-id_admission_campaign');

        if(confirm("Вы точно хотите удалить цифры приема?")){

            $.ajax({
                url: '/reference/delete_all_number_places_admission',
                type: 'GET',
                data: {'delete_id_admission_campaign' :  delete_id_admission_campaign_np},
                datType: 'json',
                beforeSend: function() {},
                success: function(current_hash) {
                    $('#three_step div.warning.message').empty();
                    $('#three_step .warning.message').removeClass('warning_mes');
                    $('#three_step .warning.message').addClass('goode_mes');
                    $('#three_step div.warning.message').append('<i class ="info icon"></i> Удаление цифр приема прошло успешно');

                    if(current_hash[1] == 'true'){
                        $('div#id_admission_campaign_np_' + current_hash[0]).fadeOut(600);
                        setTimeout( function(){
                                $('div#id_admission_campaign_np_' + current_hash[0]).remove();
                            }
                            , 1000);
                    }
                }
            });
        }

    });

    //удалить цифру приема
    var delete_id_competitive_group_np;
    $('#numberAdmission').on('click', '.ui.icon.button.red.stub', function(){

        if(confirm("Вы точно хотите удалить цифру приема?")){
            delete_id_competitive_group_np = $(this).parent().attr('data-id-competitive-group');
            parent_elemet_delete = $(this).parents('tbody');
            current_tr = $(this).parents('tr');

            $.ajax({
                url: '/reference/delete_number_places_admission',
                type: 'GET',
                data: {'delete_id_competitive_group' : delete_id_competitive_group_np},
                datType: 'json',
                beforeSend: function() {},
                success: function(current_hash) {
                    $('#three_step div.warning.message').empty();
                    $('#three_step .warning.message').removeClass('warning_mes');
                    $('#three_step .warning.message').addClass('goode_mes');
                    $('#three_step div.warning.message').append('<i class ="info icon"></i> Удаление цифры приема успешно');

                    if(current_hash[0] == 'true'){
                        $(current_tr).fadeOut(600);
                        setTimeout( function(){
                                $(current_tr).remove();

                                arr = parent_elemet_delete.find('tr');
                                f = 1;
                                for(var t = 0; t < arr.length-1; t++){
                                    $(arr[t]).find('td:first').text(f).hide().fadeIn(600);
                                    f++;
                                }
                            }
                            , 610);
                    }

                }
            });

        }

    });


    // загрузка вступительных экзаменов
    $("#button_load_admission_tests").click(function() {

        if (arr_id1c_admission_campaign.length == 0) {
            $('#four_step .warning.message').removeClass('goode_mes');
            $('#four_step .warning.message').addClass('warning_mes');
            $('#four_step div.warning.message').empty();
            $('#four_step div.warning.message').append('<i class ="warning icon"></i> Вы не выбрали приемную кампанию для загрузки вступительных испытаний. Вернитесь на шаг "Приемная кампания".');
        } else {

            var c = 0
            flag_refresh = 0;
            setAjaxExam(arr_id1c_admission_campaign, c);

            function setAjaxExam(arr_id1c_admission_campaign, c) {

                $.ajax({
                    url: '/reference/get_entry_exams',
                    type: 'GET',
                    data: {'id_admission_campaign': arr_id1c_admission_campaign[c], 'flag_refresh': flag_refresh},
                    datType: 'json',
                    beforeSend: function () {
                        $('#button_load_admission_tests').empty();
                        $('#button_load_admission_tests').append('<i class ="left load_button loading exchange icon"></i>Загрузить вступительные испытания');
                    },
                    success: function (current_hash) {

                        if (current_hash.length != 2) {

                            $('#button_load_admission_tests').empty();
                            $('#button_load_admission_tests').append('<i class ="left exchange icon"></i>Загрузить вступительные испытания');
                            $('#four_step .warning.message').removeClass('warning_mes');
                            $('#four_step .warning.message').addClass('goode_mes');
                            $('#four_step div.warning.message').empty();
                            $('#four_step div.warning.message').append('<i class ="info icon"></i> Загрузка вступительных испытаний прошла успешно');

                            if ($('div').is('#id_admission_campaign_ex_' + current_hash[1]) == false) {
                                $('<div class="ui segment" id="id_admission_campaign_ex_' + current_hash[1] + '"><div class="ui accordion"><div class="title"><i class="dropdown icon"></i>Приемна кампания номер ' + current_hash[0] + '</div><div class="content"><p class="transition visible" style="display: block !important;"></p><table class="ui very basic table" style="display: table !important;"><thead><tr><th>№</th><th>Наименование</th><th>Форма обучения</th><th>Основание поступления</th><th>Особое право</th><th>Наименование экзамена</th><th>Мин. проходной балл</th><th>Проритет</th><th>Форма проведения</th><th>Удалить</th></tr></thead><tbody id="admission_tests_' + current_hash[1] + '" ></tbody></table><p class="transition visible" style="display: block !important;"></p></div></div></div>').appendTo('#admissionTests').hide().fadeIn(600);
                                $('.ui.accordion').accordion({
                                    onOpen: function () {
                                        $("html, body").animate({
                                            scrollTop: $(this, '.title.active').offset().top - 40
                                        }, 1000)
                                    }
                                });
                                flag_add = 0;
                            } else {
                                flag_add = 1;
                            }

                            var last_id_competitive_group = 0;
                            var l = 1;

                            for (var j = 2; j < current_hash.length; j++) {
                                // получение значенией текущего хэша
                                $.each(current_hash[j], function (key, value) {
                                    if (key == 'id_competitive_group') {
                                        id_competitive_group = value;
                                    } else if (key == 'name_exam') {
                                        name_exam = value;
                                    } else if (key == 'min_ball') {
                                        min_ball = value;
                                    } else if (key == 'prioripy') {
                                        prioripy = value;
                                    } else if (key == 'form_conduct') {
                                        form_conduct = value;
                                    } else if (key == 'row_height') {
                                        row_height = value;
                                    }
                                });


                                if (last_id_competitive_group != id_competitive_group) {
                                    last_id_competitive_group = id_competitive_group;
                                    // получение конкурсных групп загруженых на 2 шаге и добавление в них места приема
                                    $('#two_step #id_admission_campaign_' + current_hash[1] + ' tbody > tr').each(function () {

                                        if ($(this).children('td:last').attr('data-id-competitive-group') == id_competitive_group) {

                                            clone_current_tr = $(this).clone();

                                            $(clone_current_tr).attr('data-id-competitive-group', id_competitive_group);
                                            $(clone_current_tr).attr('class', 'score');
                                            $(clone_current_tr).find('td').attr('rowspan', row_height);
                                            last_td = $(clone_current_tr).find('td:last');
                                            //$(clone_current_tr).find('td:first').text(l++);
                                            $(last_td).before('<td class="padding_tr">' + name_exam + '</td><td>' + min_ball + '</td><td>' + prioripy + '</td><td>' + form_conduct + '</td>');

                                            if (flag_add == 0) {
                                                $(clone_current_tr).find('td:first').text(l++);
                                                $(clone_current_tr).appendTo('tbody#admission_tests_' + current_hash[1]).hide().fadeIn(600);
                                            } else {
                                                last_number_ex = $('tbody#admission_tests_' + current_hash[1] + ' .score').length;
                                                new_last_number_ex = Number(last_number_ex) + 1;
                                                // console.log(new_last_number_ex);
                                                $(clone_current_tr).find('td:first').text(new_last_number_ex);
                                                $('tbody#admission_tests_' + current_hash[1] + ' > tr:last').before(clone_current_tr).prev().hide().fadeIn(600);
                                            }


                                        }
                                    });


                                } else {

                                    if (flag_add == 0) {
                                        $('<tr data-id-competitive-group="' + id_competitive_group + '"><td>' + name_exam + '</td><td>' + min_ball + '</td><td>' + prioripy + '</td><td>' + form_conduct + '</td></tr>').appendTo('tbody#admission_tests_' + current_hash[1]).hide().fadeIn(600);
                                    } else {
                                        $('tbody#admission_tests_' + current_hash[1] + ' > tr:last').before('<tr data-id-competitive-group="' + id_competitive_group + '"><td>' + name_exam + '</td><td>' + min_ball + '</td><td>' + prioripy + '</td><td>' + form_conduct + '</td></tr>').prev().hide().fadeIn(600);
                                    }

                                }
                            }

                            if ($('td').is('[data-id_admission_campaign_ex=' + current_hash[1] + ']') == false) {
                                $('<tr><td></td><td></td><td></td><td colspan="4" class="stub_refresh_admission_tests" data-id_admission_campaign_ex="' + current_hash[0] + '"><div class="ui right floated right labeled icon blue button" id="button_refresh_admission_tests"><i class="right refresh icon"></i>Обновить весь список</div></td><td colspan="3" data-id_admission_campaign_ex="' + current_hash[1] + '"><div class="ui right floated right labeled icon red button" id="button_remove_admission_tests"><i class="right trash icon"></i>Удалить весь список</div></td></tr>').appendTo('tbody#admission_tests_' + current_hash[1]).hide().fadeIn(600);
                            }

                        } else {
                            $('#button_load_admission_tests').empty();
                            $('#button_load_admission_tests').append('<i class ="left exchange icon"></i>Загрузить вступительные испытания');
                            $('#four_step .warning.message').removeClass('goode_mes');
                            $('#four_step .warning.message').addClass('warning_mes');
                            $("#four_step div.warning.message").empty();
                            $("#four_step div.warning.message").append('<i class ="warning icon"></i> Не удалось загрузить вступительные испытания');
                        }

                        c++;
                        if(c < arr_id1c_admission_campaign.length){setAjaxExam(arr_id1c_admission_campaign, c);}
                    }
                });
            }
        }
    });

    // обновление вступительных испытаний
    $('#admissionTests').on('click', '#button_refresh_admission_tests', function(){

        refresh_id_admission_campaign = $(this).closest('.stub_refresh_admission_tests').attr('data-id_admission_campaign_ex');
        flag_refresh = 1;

        $.ajax({
            url: '/reference/get_entry_exams',
            type: 'GET',
            data: {'id_admission_campaign': refresh_id_admission_campaign, 'flag_refresh': flag_refresh},
            datType: 'json',
            beforeSend: function () {
                $('#button_refresh_admission_tests').empty();
                $('#button_refresh_admission_tests').append('<i class ="right load_button loading refresh icon"></i>Обновить весь список');

            },
            success: function (current_hash){

                $('#button_refresh_admission_tests').empty();
                $('#button_refresh_admission_tests').append('<i class ="left refresh icon"></i>Обновить весь список');
                $('#four_step .warning.message').removeClass('warning_mes');
                $('#four_step .warning.message').addClass('goode_mes');
                $("#four_step div.warning.message").empty();
                $("#four_step div.warning.message").append('<i class ="info icon"></i> Обновление вспупительных испытаний прошла успешно');

                var last_id_competitive_group = 0;

                for (var j = 2; j < current_hash.length; j++) {
                    // получение значенией текущего хэша
                    $.each(current_hash[j], function (key, value) {
                        if (key == 'id_competitive_group') {
                            id_competitive_group = value;
                        } else if (key == 'name_exam') {
                            name_exam = value;
                        } else if (key == 'min_ball') {
                            min_ball = value;
                        } else if (key == 'prioripy') {
                            prioripy = value;
                        } else if (key == 'form_conduct') {
                            form_conduct = value;
                        } else if (key == 'row_height') {
                            row_height = value;
                        }
                    });


                    if (last_id_competitive_group != id_competitive_group) {
                        last_id_competitive_group = id_competitive_group;
                        count_tr = 0;
                        tr_find = $('#admission_tests_' + current_hash[1]).find('tr[data-id-competitive-group = "' + id_competitive_group + '"]');
                        $(tr_find).find('td[rowspan]').attr('rowspan', row_height);
                        $(tr_find).find('td:eq(5)').text(name_exam).hide().fadeIn(600);
                        $(tr_find).find('td:eq(6)').text(min_ball).hide().fadeIn(600);
                        $(tr_find).find('td:eq(7)').text(prioripy).hide().fadeIn(600);
                        $(tr_find).find('td:eq(8)').text(form_conduct).hide().fadeIn(600);
                        count_tr++;
                    } else {
                        tr_find = $('#admission_tests_' + current_hash[1]).find('tr[data-id-competitive-group = "' + id_competitive_group + '"]:eq(' + count_tr + ')');
                        $(tr_find).find('td:eq(0)').text(name_exam).hide().fadeIn(600);
                        $(tr_find).find('td:eq(1)').text(min_ball).hide().fadeIn(600);
                        $(tr_find).find('td:eq(2)').text(prioripy).hide().fadeIn(600);
                        $(tr_find).find('td:eq(3)').text(form_conduct).hide().fadeIn(600);
                        count_tr++
                    }

                }

            }
        });

    });


    // удаление всех вступительных экзаменов
    $('#admissionTests').on('click', '#button_remove_admission_tests', function(){

        delete_id_admission_campaign_ex = $(this).parent().attr('data-id_admission_campaign_ex');

        if(confirm("Вы точно хотите удалить все вступительные экзамены?")){

            $.ajax({
                url: '/reference/delete_all_entry_exams',
                type: 'GET',
                data: {'delete_id_admission_campaign' :  delete_id_admission_campaign_ex},
                datType: 'json',
                beforeSend: function() {},
                success: function(current_hash) {
                    $('#four_step div.warning.message').empty();
                    $('#four_step .warning.message').removeClass('warning_mes');
                    $('#four_step .warning.message').addClass('goode_mes');
                    $('#four_step div.warning.message').append('<i class ="info icon"></i> Удаление вступительных испытаний прошло успешно');

                    if(current_hash[1] == 'true'){
                        $('div#id_admission_campaign_ex_' + current_hash[0]).fadeOut(600);
                        setTimeout( function(){
                                $('div#id_admission_campaign_ex_' + current_hash[0]).remove();
                            }
                            , 1000);
                    }
                }
            });
        }

    });

    //удалить вступительный экзамен
    $('#admissionTests').on('click', '.ui.icon.button.red.stub', function(){

        if(confirm("Вы точно хотите удалить вступительные экзамены?")){

            delete_id_competitive_group_ex = $(this).parents('tr').attr('data-id-competitive-group');
            parent_elemet_delete = $(this).parents('tbody');
            arr_tr = parent_elemet_delete.find('tr[data-id-competitive-group = "' + delete_id_competitive_group_ex + '"]');

            $.ajax({
                url: '/reference/delete_entry_exams',
                type: 'GET',
                data: {'delete_id_competitive_group' : delete_id_competitive_group_ex},
                datType: 'json',
                beforeSend: function() {},
                success: function(current_hash) {
                    $('#four_step div.warning.message').empty();
                    $('#four_step .warning.message').removeClass('warning_mes');
                    $('#four_step .warning.message').addClass('goode_mes');
                    $('#four_step div.warning.message').append('<i class ="info icon"></i> Удаление вступительных экзаменов прошло успешно');

                    if(current_hash[0] == 'true'){
                        for(var r = 0; r < arr_tr.length; r++){
                            $(arr_tr[r]).fadeOut(600);
                        }


                        setTimeout( function(){
                                for(var e = 0; e < arr_tr.length; e++){
                                    $(arr_tr[e]).remove();
                                }
                                arr = parent_elemet_delete.find('tr.score');
                                f = 1;
                                for(var t = 0; t < arr.length; t++){
                                    $(arr[t]).find('td:first').text(f).hide().fadeIn(600);
                                    f++;
                                }
                            }
                            , 610);
                    }

                }
            });

        }

    });


    //загрузка количества поданных завлений
    $('#button_load_quantity_app_app').click(function() {

        if (arr_id1c_admission_campaign.length == 0) {
            $('#five_step .warning.message').removeClass('goode_mes');
            $('#five_step .warning.message').addClass('warning_mes');
            $('#five_step div.warning.message').empty();
            $('#five_step div.warning.message').append('<i class ="warning icon"></i> Вы не выбрали приемную кампанию для загрузки цифр приема. Вернитесь на шаг "Приемная кампания".');
        } else {

            flag_refresh = 0;
            var c = 0
            setAjaxQuantityApplicableApplication(arr_id1c_admission_campaign, c);

            function setAjaxQuantityApplicableApplication(arr_id1c_admission_campaign, c) {

                $.ajax({
                    url: '/reference/get_quantity_applicable_applications',
                    type: 'GET',
                    data: {'id_admission_campaign': arr_id1c_admission_campaign[c], 'flag_refresh': flag_refresh},
                    datType: 'json',
                    beforeSend: function () {
                        //добавлние ярлыка загрузки
                        $('#button_load_quantity_app_app').empty();
                        $('#button_load_quantity_app_app').append('<i class ="left load_button loading exchange icon"></i>Загрузить количество поданных заявлений');

                    },
                    success: function (current_hash) {

                        if (current_hash.length != 2) {

                            $('#button_load_quantity_app_app').empty();
                            $('#button_load_quantity_app_app').append('<i class ="left exchange icon"></i>Загрузить количество поданных заявлений');
                            $('#five_step .warning.message').removeClass('warning_mes');
                            $('#five_step .warning.message').addClass('goode_mes');
                            $('#five_step div.warning.message').empty();
                            $('#five_step div.warning.message').append('<i class ="info icon"></i> Загрузка количества поданных заявлений успешно');

                            if ($('div').is('#id_admission_campaign_qaa_' + current_hash[1]) == false) {
                                $('<div class="ui segment" id = "id_admission_campaign_qaa_' + current_hash[1] + '"><div class="ui accordion"><div class="title"><i class="dropdown icon"></i>Приемна кампания номер ' + current_hash[0] + '</div><div class="content"><p class="transition visible" style="display: block !important;"></p><table class="ui very basic table transition visible" style="display: table !important;"><thead><tr><th>№</th><th>Наименование</th><th>Форма обучения</th><th>Основание поступления</th><th>Особое право</th><th>Количество заявлений</th><th>Удалить</th></tr></thead><tbody id = "quantity_app_app_' + current_hash[1] + '" ></tbody></table><p class="transition visible" style="display: block !important;"></p></div></div></div>').appendTo('#quantityAppApp').hide().fadeIn(600);

                                $('.ui.accordion').accordion({
                                    onOpen: function () {
                                        $("html, body").animate({
                                            scrollTop: $(this, '.title.active').offset().top - 40
                                        }, 1000)
                                    }
                                });
                                flag_laod = 0;
                            } else {
                                flag_laod = 1;
                            }


                            for (var j = 2; j < current_hash.length; j++) {
                                // получение значенией текущего хэша
                                $.each(current_hash[j], function (key, value) {
                                    if (key == 'abitur_admission_campaign_id') {
                                        abitur_admission_campaign_id = value;
                                    } else if (key == 'abitur_competitive_group_id') {
                                        abitur_competitive_group_id = value;
                                    } else if (key == 'number_applicable_application') {
                                        number_applicable_application = value;
                                    }

                                });


                                // получение конкурсных групп загруженых на 2 шаге и добавление в них цифры подыных завлени
                                $('#two_step #id_admission_campaign_' + current_hash[1] + ' tbody > tr').each(function () {

                                    if ($(this).children('td:last').attr('data-id-competitive-group') == abitur_competitive_group_id) {

                                        clone_current_tr = $(this).clone();

                                        if (flag_laod == 1 && $('#quantity_app_app_' + abitur_admission_campaign_id + ' td').is('[data-id-competitive-group="' + abitur_competitive_group_id + '"]') != true) {

                                            last_number = $('#id_admission_campaign_qaa_' + current_hash[1] + ' .stub_refresh').length;
                                            new_last_number = Number(last_number) + 1;
                                            first_td = $(clone_current_tr).find('td:first').text(new_last_number);
                                            last_td = $(clone_current_tr).find('td:last');
                                            $(last_td).before('<td class="stub_refresh" >' + number_applicable_application + '</td>');
                                            $('tbody#quantity_app_app_' + abitur_admission_campaign_id + ' > tr:last').before(clone_current_tr).prev().hide().fadeIn(600);

                                        } else if (flag_laod == 0 && $('#quantity_app_app_' + abitur_admission_campaign_id + ' td').is('[data-id-competitive-group="' + abitur_competitive_group_id + '"]') != true) {

                                            last_td = $(clone_current_tr).find('td:last');
                                            $(last_td).before('<td class="stub_refresh" >' + number_applicable_application + '</td>');
                                           // $(clone_current_tr).appendTo('tbody#quantity_app_app_' + abitur_admission_campaign_id).hide().fadeIn(600);
                                            $('tbody#quantity_app_app_' + abitur_admission_campaign_id).append(clone_current_tr).hide().fadeIn(600);
                                        }

                                    }

                                });
                            }

                            if ($('td').is('[data-id_admission_campaign_qaa=' + current_hash[0] + ']') == false) {
                                $('<tr><td colspan="4" class="stub_refresh_quantity_app_app" data-id_admission_campaign_qaa="' + current_hash[0] + '" ><div class="ui right floated right labeled icon blue button" id="button_refresh_quantity_app_app"><i class="right refresh icon"></i>Обновить весь список</div></td><td colspan="3" class="stub_remove_quantity_app_app" data-id_admission_campaign = "' + current_hash[1] + '"><div class="ui right floated right labeled icon red button" id="button_remove_quantity_app_app"><i class="right trash icon"></i>Удалить весь список</div></td></tr>').appendTo('tbody#quantity_app_app_' + current_hash[1]).hide().fadeIn(600);
                            }

                        } else {
                            $('#button_load_quantity_app_app').empty();
                            $('#button_load_quantity_app_app').append('<i class ="left exchange icon"></i>Загрузить места приёма');
                            $('#five_step .warning.message').removeClass('goode_mes');
                            $('#five_step .warning.message').addClass('warning_mes');
                            $('#five_step div.warning.message').empty();
                            $('#five_step div.warning.message').append('<i class ="warning icon"></i> Не удалось загрузить цифры приема');
                        }
                        c++;
                        if(c < arr_id1c_admission_campaign.length){setAjaxQuantityApplicableApplication(arr_id1c_admission_campaign, c);}
                    }
                });
            }
        }
    });


    // обновление колличество поданных заявлений
    $('#quantityAppApp').on('click', '#button_refresh_quantity_app_app', function(){

        refresh_id_admission_campaign = $(this).closest('.stub_refresh_quantity_app_app').attr('data-id_admission_campaign_qaa');
        flag_refresh = 1;

        $.ajax({
            url: '/reference/get_quantity_applicable_applications',
            type: 'GET',
            data: {'id_admission_campaign': refresh_id_admission_campaign, 'flag_refresh': flag_refresh},
            datType: 'json',
            beforeSend: function () {
                $('#button_refresh_quantity_app_app').empty();
                $('#button_refresh_quantity_app_app').append('<i class ="right load_button loading refresh icon"></i>Обновить весь список');
            },
            success: function (current_hash){
                $('#button_refresh_quantity_app_app').empty();
                $('#button_refresh_quantity_app_app').append('<i class ="right refresh icon"></i>Обновить весь список');
                $('#five_step .warning.message').removeClass('warning_mes');
                $('#five_step .warning.message').addClass('goode_mes');
                $('#five_step div.warning.message').empty();
                $('#five_step div.warning.message').append('<i class ="info icon"></i> Обновление цифр количества поданых завлений прошла успешно');

                for(var j = 2; j < current_hash.length; j++) {

                    $.each(current_hash[j], function (key, value) {
                        if(key == 'abitur_admission_campaign_id'){
                            abitur_admission_campaign_id = value;
                        }else if(key == 'abitur_competitive_group_id'){
                            abitur_competitive_group_id = value;
                        }else if(key == 'number_applicable_application'){
                            number_applicable_application = value;
                        }

                    });

                    tr_find = $('#id_admission_campaign_qaa_' + current_hash[1]).find('td[data-id-competitive-group = "' + abitur_competitive_group_id + '"]');
                    $(tr_find).prev('td').text(number_applicable_application).hide().fadeIn(600);

                }
            }
        });

    });


    //удалить количество поданных завлений
    $('#quantityAppApp').on('click', '.ui.icon.button.red.stub', function(){

        if(confirm("Вы точно хотите удалить количество поданных заявлений по конкурсной группе?")){
            delete_id_competitive_group_qaa = $(this).parent().attr('data-id-competitive-group');
            parent_elemet_delete = $(this).parents('tbody');
            current_tr = $(this).parents('tr');

            $.ajax({
                url: '/reference/delete_quantity_applicable_application',
                type: 'GET',
                data: {'delete_id_competitive_group' : delete_id_competitive_group_qaa},
                datType: 'json',
                beforeSend: function() {},
                success: function(current_hash) {
                    $('#five_step div.warning.message').empty();
                    $('#five_step .warning.message').removeClass('warning_mes');
                    $('#five_step .warning.message').addClass('goode_mes');
                    $('#five_step div.warning.message').append('<i class ="info icon"></i> Удаление количиства поданых заявлений по конкурсной группе прошло успешно');

                    if(current_hash[0] == 'true'){
                        $(current_tr).fadeOut(600);
                        setTimeout( function(){
                                $(current_tr).remove();

                                arr = parent_elemet_delete.find('tr');
                                var f = 1;
                                for(var t = 0; t < arr.length-1; t++){
                                    $(arr[t]).find('td:first').text(f).hide().fadeIn(600);
                                    f++;
                                }
                            }
                            , 610);
                    }
                }
            });
        }

    });

    //удаление всех количество поданных завлений
    $('#quantityAppApp').on('click', '#button_remove_quantity_app_app', function(){

        delete_id_admission_campaign_qaa =  $(this).closest('.stub_remove_quantity_app_app').attr('data-id_admission_campaign');

        if(confirm("Вы точно хотите удалить все цифры поданных заявлений?")){

            $.ajax({
                url: '/reference/delete_all_quantity_applicable_applications',
                type: 'GET',
                data: {'delete_id_admission_campaign' :  delete_id_admission_campaign_qaa},
                datType: 'json',
                beforeSend: function() {},
                success: function(current_hash) {
                    $('#five_step div.warning.message').empty();
                    $('#five_step .warning.message').removeClass('warning_mes');
                    $('#five_step .warning.message').addClass('goode_mes');
                    $('#five_step div.warning.message').append('<i class ="info icon"></i> Удаление цифр приема прошло успешно');

                    if(current_hash[1] == 'true'){
                        $('div#id_admission_campaign_qaa_' + current_hash[0]).fadeOut(600);
                        setTimeout( function(){
                                $('div#id_admission_campaign_qaa_' + current_hash[0]).remove();
                            }
                            , 1000);
                    }
                }
            });
        }
    });



    $('#admissionActiveList').on('click', '.large.icon.eye, .large.icon.eye.slash', function(){

        var current_td = $(this).parent('td');
        id =  $(this).parents('tr[data-id_admission_activ]').attr('data-id_admission_activ');

            $.ajax({
                url: '/reference/change_sleep_flag',
                type: 'GET',
                data: {'id' :  id},
                datType: 'json',
                beforeSend: function() {},
                success: function(current_respond) {
                    if(current_respond == true){
                        current_td.empty();
                        current_td.append('<i class ="large icon eye"></i>');
                        console.log(current_respond);
                    }else{
                        current_td.empty();
                        current_td.append('<i class ="large icon eye slash"></i>');
                        console.log(current_respond);
                    }

                }
            });
    });


    $('#admissionActiveList').on('click', '.large.icon.bell, .large.icon.bell.slash', function(){

        var current_td = $(this).parent('td');
        id =  $(this).parents('tr[data-id_admission_activ]').attr('data-id_admission_activ');

        $.ajax({
            url: '/reference/change_admission_cabinet_flag',
            type: 'GET',
            data: {'id' :  id},
            datType: 'json',
            beforeSend: function() {},
            success: function(current_respond) {
                if(current_respond == true){
                    current_td.empty();
                    current_td.append('<i class ="large icon bell"></i>');
                    console.log(current_respond);
                }else{
                    current_td.empty();
                    current_td.append('<i class ="large icon bell slash"></i>');
                    console.log(current_respond);
                }

            }
        });
    });

    // изменение флага cron для обновлния экзаменов
    $('#flag_exam').change(function(){
        value_flag = $(this).prop('checked');
        //console.log(value_flag);
        $.ajax({
            url: '/reference/save_cron_flag',
            type: 'GET',
            data: {'value_flag' :  value_flag}
        });
    });

    // загрузка флага cron для обновлния экзаменов
   /* $.ajax({
        url: '/reference/get_cron_flag',
        type: 'GET',
        datType: 'json',
        success: function(current_respond) {
            if(current_respond != null){
                console.log(current_respond);
                $('#flag_exam').prop('checked', current_respond);
            }

        }
    });*/

});